/* eslint-disable array-callback-return */
import React from "react"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography, Stack, IconButton } from "@mui/material"

import ModeEdit from '@mui/icons-material/ModeEdit'
import Delete from '@mui/icons-material/Delete'
import List from '@mui/icons-material/List'
import Visibility from '@mui/icons-material/Visibility'
import Print from "@mui/icons-material/Print"

export default function TableInfo(props) {
  const { columns, rows, edit, deactive, list, view, printLabel } = props
  const variants = [{
    type: 'success',
    color: 'linear-gradient(to left , #66BB6A, #43A047)',
  },
  {
    type: 'info',
    color: 'linear-gradient(to right , #1A73E8, #49a3f1)'
  },
  {
    type: 'secondary',
    color: 'linear-gradient(to left , #747b8a, #495361)'
  }]

  function isVariant() {
    const [variant] = variants.filter(variant => variant.type === props.variant)
    return variant.color
  }

  return (
    <Box sx={{ width: '100%', overflow: 'hidden', }} >
      <Box mx={'auto'}
        sx={{
          width: '92%', height: '30px', display: 'flex', color: 'white', justifyContent: 'start',
          textAlgin: 'left', padding: 3, background: isVariant(),
          borderRadius: 2
        }}>
        <Typography variant={'h6'} sx={{ alignSelf: 'center' }}>{props.title}</Typography>
      </Box>
      <Paper elevation={4} sx={{ justifyContent: 'center', width: '90%', margin: '0 auto' }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.width }}
                  >
                    {column.Header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? rows.map((row, index) => {
                const eventId = row.id
                const subscriberId = row.id
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map((column) => {
                      const value = row.attributes[column.accessor];
                      
                      // Se a coluna tem um Cell customizado, usa ele
                      if (column.Cell) {
                        return (
                          <TableCell key={column.accessor}>
                            {column.Cell({ value, row: { original: row } })}
                          </TableCell>
                        );
                      }
                      
                      if (column.Header == 'Status') return (
                        <TableCell key={column.accessor}>
                          {value ? 'Publicado' : 'Rascunho'}
                        </TableCell>
                      )
                      if (column.Header == 'Tipo' || column.Header == 'Filiado' || column.Header == 'Bloqueado') return (
                        <TableCell key={column.accessor}>
                          {row.attributes['affiliate'] && row.attributes['affiliate']['data'] ? (column.Header == 'Tipo' ? row.attributes['affiliate']['data']['attributes']['type'] : column.Header == 'Filiado' ? (row.attributes['affiliate']['data']['attributes']['active'] ? 'Sim' : 'Não') : (row.attributes['affiliate']['data']['attributes']['blocked'] ? 'Sim' : 'Não')) : '-'}
                        </TableCell>
                      )
                      if (value || value == 0) return (
                        <TableCell key={column.accessor}>
                          {value || '0'}
                        </TableCell>
                      );
                      if (value == undefined && column.Header !== 'Ações' && column.Header !== 'Etiqueta' && column.Header !== 'Files') return (
                        <TableCell key={column.accessor}>
                          {'-'}
                        </TableCell>
                      )

                      if (column.Header === 'Ações') return (
                        <TableCell key={column.accessor}>
                          <Stack direction="row" spacing={0}>
                            <IconButton aria-label="edit" color="primary" onClick={() => edit(eventId)}>
                              <ModeEdit />
                            </IconButton>
                            {list && <IconButton aria-label="list" color="warning" onClick={() => list({ id: eventId })}>
                              <List />
                            </IconButton>}
                            <IconButton aria-label="delete" color="error" onClick={() => deactive(eventId)} >
                              <Delete />
                            </IconButton>
                          </Stack>
                        </TableCell>
                      )
                      if (column.Header === 'Etiqueta') return (
                        <TableCell key={column.accessor}>
                          <Stack direction="row" spacing={0}>
                            <IconButton aria-label="edit" color="primary" onClick={() => printLabel(subscriberId)}>
                              <Print />
                            </IconButton>
                          </Stack>
                        </TableCell>
                      )
                      if (column.Header === 'Files') return (
                        <TableCell key={column.accessor}>
                          <Stack direction="row" spacing={0}>
                            {edit && <IconButton aria-label="edit" color="primary" onClick={() => edit({ id: eventId })}>
                              <ModeEdit />
                            </IconButton>}
                            <IconButton aria-label="list" color="warning" onClick={() => view({ id: eventId })}>
                              <Visibility />
                            </IconButton>
                            <IconButton aria-label="delete" color="error" onClick={() => deactive({ id: eventId })} >
                              <Delete />
                            </IconButton>
                          </Stack>
                        </TableCell>
                      )
                    })}
                  </TableRow>
                );
              }) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box >
  )
}